"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        position: 'absolute',
        marginLeft: 11
    },
    input: {
        display: 'block',
        flexGrow: 1,
        appearance: 'none',
        boxSizing: 'border-box',
        outline: 'none',
        backgroundColor: theme.white1,
        height: 32,
        width: 300,
        padding: 3,
        border: `1px solid ${theme.grey5}`,
        fontSize: 13,
        color: theme.indigo3,
        boxShadow: `0px 4px 8px #34323A4D`,
        '&::placeholder': {
            color: theme.grey4
        }
        // Until we decide on a proper way to warn the user about invalid url
        // '&[data-is-notvalid="true"]': {
        //   borderColor: theme.warningRed
        // }
    }
});
//# sourceMappingURL=urlInput.style.js.map